interface ClockTheme {
  slug: string;
  hourOn: string;
  hourOff: string;
  minOn: string;
  minOff: string;
  border: string;
}

const RedYellow: ClockTheme = {
  slug: "red-yellow",
  hourOn: " bg-red-400 ",
  hourOff: " bg-red-100 ",
  minOn: " bg-yellow-400 ",
  minOff: " bg-yellow-100 ",
  border: "red-400",
};

const Slate: ClockTheme = {
  slug: "slate",
  hourOn: " bg-slate-500 ",
  hourOff: " bg-slate-200 ",
  minOn: " bg-slate-400 ",
  minOff: " bg-slate-100 ",
  border: " slate-500 ",
};

const Cyan: ClockTheme = {
  slug: "cyan",
  hourOn: " bg-cyan-500 ",
  hourOff: " bg-cyan-200 ",
  minOn: " bg-cyan-300 ",
  minOff: " bg-cyan-100 ",
  border: " cyan-500 ",
};

const Teal: ClockTheme = {
  slug: "teal",
  hourOn: " bg-teal-500 ",
  hourOff: " bg-teal-200 ",
  minOn: " bg-teal-300 ",
  minOff: " bg-teal-100 ",
  border: " teal-500 ",
};

const BlueGreen: ClockTheme = {
  slug: "blue-green",
  hourOn: " bg-sky-500 ",
  hourOff: " bg-sky-100 ",
  minOn: " bg-emerald-400 ",
  minOff: " bg-emerald-100 ",
  border: " sky-500 ",
};

const THEME_MAP: Map<string, ClockTheme> = new Map([
  ["blue-green", BlueGreen],
  ["cyan", Cyan],
  ["slate", Slate],
  ["teal", Teal],
  ["red-yellow", RedYellow],
]);

export { RedYellow, Slate, Cyan, Teal, BlueGreen, THEME_MAP };
export type { ClockTheme };
